// $(".cstm-order-complain-tab").click(function() {
// 	$(".modal.order-popup").show();
// });

// $(".order-popup .modal-dialog .modal-content .modal-header button.close").click(function() {
// 	$(".modal.order-popup").hide();
//   console.log('bilal')
// });

// $(".cstm-order-complain-tab-mobile").click(function() {
// 	$(".modal.order-popup").show();
  
//           $('html').removeClass('open-mn');
//           $('html').removeClass('open-user');


document.addEventListener('DOMContentLoaded', function () {
  const clickHere = document.querySelector('.cstm-order-complain-tab');
  const complain = document.querySelector('.modal.order-popup');
  const closeBtn = document.querySelector('.modal.order-popup .close');

  if (!clickHere || !complain || !closeBtn) {
    console.warn('One or more elements not found!');
    return;
  }

  clickHere.addEventListener('click', function () {
    complain.classList.remove('hide-b');
    console.log('Modal opened');
  });

  closeBtn.addEventListener('click', function () {
    complain.classList.add('hide-b');
    console.log('Modal closed');
  });
});

